import * as React from 'react'

const SvgArrowDownCircleOutlined = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 25"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      fill="#60636B"
      fillRule="evenodd"
      d="M12.5 20.926a8.25 8.25 0 1 0 0-16.5 8.25 8.25 0 0 0 0 16.5m9.75-8.25c0 5.385-4.365 9.75-9.75 9.75s-9.75-4.365-9.75-9.75 4.365-9.75 9.75-9.75 9.75 4.365 9.75 9.75m-10.28 4.28-3-3a.75.75 0 1 1 1.06-1.06l1.55 1.548a.1.1 0 0 0 .17-.07V8.676a.75.75 0 0 1 1.5 0v5.698a.1.1 0 0 0 .17.07l1.55-1.549a.75.75 0 1 1 1.06 1.061l-3 3a.75.75 0 0 1-1.06 0"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgArrowDownCircleOutlined
